<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-input
			  v-model="key"
			  placeholder="请输入搜索关键词"
			  class="input-with-select"
			>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%" height="680">
	    <el-table-column fixed prop="booking_reference_no" label="航班号" width="100" />
	    <el-table-column fixed prop="klook_order_status" label="订单状态" width="100" />
		<el-table-column fixed prop="travel_time" label="使用时间" width="180" />
	    <el-table-column prop="origin_name" label="出发地址" width="320" />
	    <el-table-column prop="dest_name" label="目的地址" width="320" />
	    <el-table-column prop="passenger_num" label="乘客人数" width="80" />
		<el-table-column prop="flight_number" label="航班号" width="120" />
		<el-table-column prop="memo" label="备注" width="150" />
	    <el-table-column fixed="right" label="操作" width="*">
	      <template #default="scope">
	        <el-button link type="primary" size="small" @click="handleDtClick(scope.row)">详情</el-button>
			<el-button link type="primary" size="small" @click="addBzClick(scope.row)">添加备注</el-button>
			<el-button link type="primary" size="small" @click="assignDriver(scope.row)">推送分配司机</el-button>
			<el-button v-if="scope.row.driver&&scope.row.vehicle" link type="primary" size="small" @click="checkDriver(scope.row)">查看司机</el-button>
	      </template>
	    </el-table-column>
	</el-table>
	<div class="pagination-custom">
		<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
	</div>
	<el-dialog
		@close="closeDtDialog"
	    v-model="jsjDialogVisible"
	    title="订单详情"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<DataForm />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="closeDtDialog">关闭</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
		@close="closeDriverDialog"
	    v-model="driverDialogVisible"
	    title="订单分配司机-车辆"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-form
		    ref="form"
		    :model="sizeForm"
		    label-width="auto"
		    label-position="right"
		    size="default"
		  >
			<h4>
				司机
			</h4>
			<div style="display: flex;">
				<el-form-item label="姓" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.driver?.last_name}}</el-text>
				</el-form-item>
				<el-form-item label="名" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.driver?.first_name}}</el-text>
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="手机号" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.driver?.telephone}}</el-text>
				</el-form-item>
			</div>
			<h5>
				司机其他联系方式
			</h5>
			<div style="display: flex;" v-for="(item, index) in sizeForm.driver?.other_contact" :key="index">
				<el-form-item label="联系类型" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{item.type}}</el-text>
				</el-form-item>
				<el-form-item label="内容" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{item.content}}</el-text>
				</el-form-item>
			</div>
			<h4>
				车辆信息
			</h4>
			<div style="display: flex;">
				<el-form-item label="制造商" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.vehicle?.make}}</el-text>
				</el-form-item>
				<el-form-item label="车型" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.vehicle?.model}}</el-text>
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="颜色" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.vehicle?.colour}}</el-text>
				</el-form-item>
				<el-form-item label="车牌号" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.vehicle?.plate_number}}</el-text>
				</el-form-item>
			</div>
			<div style="display: flex;">
				<!-- <el-form-item label="" style="width: 48%;">
				  <el-text class="mx-1" type="primary">{{sizeForm.vehicle?.car_number}}</el-text>
				</el-form-item> -->
				<el-form-item label="图片" style="width: 48%;">
				  <img :src="sizeForm.vehicle?.cover_image" class="avatar" />
				</el-form-item>
			</div>
		</el-form>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="closeDriverDialog">关闭</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
	    v-model="bzDialogVisible"
	    title="添加备注"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-input class="w-50 m-2" v-model="newBz" />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="bzDialogVisible = false">关闭</el-button>
		    <el-button type="primary" @click="saveBz">保存</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
		@close="assignDriverDialog"
	    v-model="assignDialogVisible"
	    title="分配司机"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-form
		    ref="formSjdd"
		    :model="sjddForm"
		    label-width="auto"
		    label-position="right"
		    size="default"
		  >
			<div style="display: flex;">
				<el-form-item label="选择司机" style="width: 600px;" prop="xm" :rules="[{ required: true, message: 'driver is required' }]">
				  <el-select
				  	v-model="sjddForm.xm"
				  	filterable
				  	placeholder="选择司机"
				  	style="width: 540px"
				  >
				  	<el-option
				  	  v-for="item in sjddSjDatas"
				  	  :key="item.value"
				  	  :label="item.label"
				  	  :value="item.value"
				  	/>
				  </el-select>
				</el-form-item>
			</div>
			<div style="display: flex;">
				<el-form-item label="选择车辆" style="width: 600px;" prop="sjddcl" :rules="[{ required: true, message: 'vehicle is required' }]">
					<el-select
						v-model="sjddForm.sjddcl"
						filterable
						placeholder="选择车辆"
						style="width: 540px"
					>
						<el-option
						  v-for="item in sjddclDatas"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value"
						/>
					</el-select>
				</el-form-item>
			</div>
		</el-form>
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="assignDriverDialog">关闭</el-button>
			<el-button type="primary" @click="saveAssign">保存</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,provide,inject,onMounted } from 'vue';
	import axios from 'axios';
	import DataForm from './ordersInfo.vue';
	import { useMemberStore } from '../../stores';
	import { ElMessage } from 'element-plus'
	import JSONbig from "json-bigint";
	const userStore = useMemberStore();
	const bzDialogVisible = ref(false)
	const newBz = ref('')
	const addBzClick=(e)=>{
		billid.value = e.id
		bzDialogVisible.value = true;
	}
	const saveBz=async()=>{
		const response = await axios.post('/klook/orders/saveBz', {
		  billid:billid.value,
		  bz:newBz.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '信息保存成功!',
				type: 'success',
			})
		}else{
			ElMessage.error('哦,信息保存失败!')
		}
		tableData.value.map(item=>{
			if(item.id===billid.value){
				item.memo = newBz.value;
			}
		})
		bzDialogVisible.value = false;
	}
	const closeDriverDialog=()=>{
		driverDialogVisible.value = false
	}
	const driverDialogVisible = ref(false)
	const assignDialogVisible = ref(false)
	const formSjdd = ref(null);
	const sjddForm = ref({
		sjddcl:'',
		xm:'',
	})
	const sjddclDatas = ref([]);
	const sjddSjDatas = ref([]);
	const sizeForm = ref({
		driver:null,
		vehicle:null
	})
	const checkDriver = async(e) =>{
		driverDialogVisible.value = true
		const respDriver = await axios.post('/klook/orders/queryOrderDriver',{
			driver:e.driver,
			vehicle:e.vehicle
		},{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(respDriver.data.status===0){
			sizeForm.value = respDriver.data.data
		}
	}
	const assignDriver = async(e)=>{
		assignDialogVisible.value = true;
		billid.value = e.booking_reference_no //分配司机时不再是数据ID，是订单编号，后台可以直接使用  不需要查询
		//查询司机、车辆信息
		const respDriver = await axios.get('/klook/driver/getSelectList',{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(respDriver.data.status===0){
			sjddSjDatas.value = respDriver.data.data;
		}
		const respVehicle = await axios.get('/klook/car/getSelectList',{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(respVehicle.data.status===0){
			sjddclDatas.value = respVehicle.data.data;
		}
	}
	const saveAssign = async()=>{
		if(!sjddForm.value.xm||!sjddForm.value.sjddcl){
			return ElMessage.error('请选择司机、车辆后保存!')
		}
		const respDriver = await axios.post('/klook/driver/assignDriver',{
			booking_reference_no:billid.value,
			driver_id:sjddForm.value.xm,
			vehicle_id:sjddForm.value.sjddcl
		},{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(respDriver.data.status===0){
			ElMessage({
				message: '司机分配成功!',
				type: 'success',
			})
		}else{
			ElMessage.error('哦,司机分配失败了!')
		}
		assignDriverDialog();
	}
	const assignDriverDialog = ()=>{
		assignDialogVisible.value = false;
	}
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const searchType = ref(0);
	const key = ref('');
	const type = ref('');
	const tableData = ref([]);
	const jsjDialogVisible = ref(false);//详情
	const billid = ref('');
	provide('billid', billid);
	onMounted(async()=>{
		const response = await axios.post('/klook/orders/getList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = JSONbig.parse(response.data.data);
			total.value = parseInt(response.data.total);
		}
	})
	const fetchOrders = async () => {
		searchType.value = 0;
		const response = await axios.post('/klook/orders/getList', {
		  value: key.value,
		  key:'a.booking_reference_no',
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = JSONbig.parse(response.data.data);
			total.value = parseInt(response.data.total);
		}
	};
	const handleDtClick = (e)=>{
		billid.value = e.id;
		jsjDialogVisible.value = true;
	}
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
	const closeDtDialog=()=>{
		jsjDialogVisible.value = false;
	}
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
</style>